/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-nested-ternary */
import { ToastContainer } from 'react-toastify'
import { BelowInput } from '../../components/BelowInput/BelowInput'
import { Input } from '../../components/Input/Input'
// import LoginImg2 from '../../assets/images/LoginImg2.png'
import {
  AreaLogin,
  Bloco,
  Container,
  RealizeSeuLogin,
  TituloGrupo,
  Wrapper,
  WrapperEsqueciSenha,
  VoltarLogin,
  WrapperEmailEnviado,
} from '../../components/PageLoginStyle/PageLogin.style'
import { CheckedIcon } from '../../assets/icons/Checked'
import { LogoCartivia } from '../../components/LogoCartivia'
import { AvisoRebranding } from '../../components/AvisoRebranding'

import {
  EmailEnviado,
  IconEmail,
  MsgEmailEnviado,
  SubTitle,
  Title,
} from '../../components/TitleLogin/Title.style'
import 'react-toastify/dist/ReactToastify.css'
import { useLogin } from './useLogin'
import ArrowLeft from '../../assets/icons/arrowLeft'

export function Login() {
  const {
    setEmail,
    email,
    password,
    setPassword,
    doLogin,
    handleKeyDown,

    isEqueciSenha,
    emailEnviado,
    handleBackToLogin,
    handleEmailEnviado,
  } = useLogin()

  return (
    <Container>
      <ToastContainer position="top-left" theme="dark" />
      {emailEnviado ? (
        isEqueciSenha ? (
          <AreaLogin>
            <Wrapper>
              <LogoCartivia vertical comTagline tamanho={32} />
              <Title titleType="SUB-TITLE">Realize seu Login</Title>
              <Input
                labelText="E-mail"
                value={email}
                onChange={event => setEmail(event.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Insira seu usuário"
              />
              <Input
                labelText="Senha"
                value={password}
                onChange={event => setPassword(event.target.value)}
                changeIsPassword
                onKeyDown={handleKeyDown}
                placeholder="Insira sua senha"
              />
              <BelowInput
                isLembrarMe
                buttonText="Entrar"
                onclick={doLogin}
                // isLoading={isLoading}
                esqueciSenha={handleBackToLogin}
              />
            </Wrapper>
            {/* Depois do cartao no DOM de proposito: assim o formulario e o
                primeiro tab stop e, quando os dois empilham no celular, o login
                fica em cima — quem so quer entrar nao rola o comunicado antes. */}
            <AvisoRebranding />
          </AreaLogin>
        ) : (
          <RealizeSeuLogin>
            <WrapperEsqueciSenha>
              <VoltarLogin onClick={handleBackToLogin}>
                <ArrowLeft />
              </VoltarLogin>
              <LogoCartivia vertical tamanho={30} />
              <Bloco>
                <TituloGrupo>
                  <Title titleType="SUB-TITLE">Digite seu e-mail</Title>
                  <SubTitle>
                    Encaminharemos uma senha de acesso temporária.
                  </SubTitle>
                </TituloGrupo>
                <Input
                  labelText="E-mail"
                  value={email}
                  onChange={event => setEmail(event.target.value)}
                  changeIsPassword={false}
                  onKeyDown={handleKeyDown}
                  placeholder="Insira seu usuário"
                />
                <BelowInput
                  isLembrarMe={false}
                  buttonText="Enviar"
                  onclick={handleEmailEnviado}
                  // isLoading={isLoading}
                />
              </Bloco>
            </WrapperEsqueciSenha>
          </RealizeSeuLogin>
        )
      ) : (
        <RealizeSeuLogin>
          <WrapperEmailEnviado>
            <VoltarLogin onClick={handleBackToLogin}>
              <ArrowLeft />
            </VoltarLogin>
            <span>
              <LogoCartivia vertical tamanho={26} />
            </span>
            <Bloco>
              <IconEmail>
                <CheckedIcon />
              </IconEmail>
              <TituloGrupo>
                <EmailEnviado>E-mail enviado! </EmailEnviado>
                <MsgEmailEnviado>
                  Verifique a caixa de entrada do <br />
                  seu e-mail e/ou a caixa de spam.
                </MsgEmailEnviado>
              </TituloGrupo>
            </Bloco>
          </WrapperEmailEnviado>
        </RealizeSeuLogin>
      )}
    </Container>
  )
}
